import { create } from 'zustand';
import type { User } from '../types/database';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  isAnonymous: boolean;
}

interface AuthActions {
  setUser: (user: User | null) => void;
  clearUser: () => void;
  setIsLoading: (isLoading: boolean) => void;
}

export type AuthStore = AuthState & AuthActions;

export const useAuthStore = create<AuthStore>((set) => ({
  // State
  user: null,
  isLoading: true,
  isAnonymous: false,

  // Actions
  setUser: (user) =>
    set({
      user,
      isAnonymous: user?.auth_provider === null,
      isLoading: false,
    }),

  clearUser: () =>
    set({
      user: null,
      isAnonymous: false,
      isLoading: false,
    }),

  setIsLoading: (isLoading) => set({ isLoading }),
}));
